import styled, { css } from 'styled-components'

import * as color from '../../constants/colors'

export const HiddenFocusableInput = styled.input`
  cursor: pointer;
  display: inline-block;
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
  margin: 0;
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 3px;

  svg {
    display: none;
  }
`

const BaseWrapper = styled.div`
  border-radius: 3px;
  height: 18px;
  position: relative;
  width: 18px;
  box-sizing: border-box;

  &:hover {
    background-color: ${color.SAND_3};
  }

  ${HiddenFocusableInput}:checked + ${Container} {
    svg {
      display: inline-block;
    }
  }

  ${HiddenFocusableInput}:disabled + ${Container} {
    svg {
      color: ${color.GRAY_1};
    }
  }

  ${HiddenFocusableInput}:hover:disabled {
    cursor: not-allowed;
  }
`

export const Wrapper = styled(BaseWrapper)<{ disabled?: boolean }>`
  ${Container} {
    ${({ disabled }) => {
      if (disabled) {
        return css`
          background-color: ${color.SAND_3};
          border: 2px solid ${color.GRAY_1};
        `
      } else {
        return css`
          border: 2px solid ${color.GRAY_3};
        `
      }
    }}
  }
`
